import { Icon, Text, Tooltip } from 'bold-ui'
import { ButtonLink } from 'components/route'
import { useRouter } from 'hooks/useRouter'
import React from 'react'

interface GrupoExameTableHeaderProps {
  quantidade: number
}

export function GrupoExameTableHeader(props: GrupoExameTableHeaderProps) {
  const { match } = useRouter()

  const isOverQuantity = props.quantidade >= 14

  const buttonToolTipText = isOverQuantity ? 'Não é possível adicionar mais de 14 grupos de exames' : ''

  return (
    <div style={{ textAlign: 'right' }}>
      <Tooltip text={buttonToolTipText} placement='auto'>
        <ButtonLink
          to={isOverQuantity ? match.url : `${match.url}/create`}
          kind='primary'
          size='small'
          disabled={isOverQuantity}
        >
          <Icon icon='plus' style={{ marginRight: '0.25rem' }} />
          <Text color='inherit'>Adicionar grupo de exames</Text>
        </ButtonLink>
      </Tooltip>
    </div>
  )
}
